export const topBarHeight = 77;
export const sideNavWidth = 270;
export const navbarHeight = 70;
export const sidenavCompactWidth = 90;
export const containedLayoutWidth = 1300;
